import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-heading text-primary-500">黑料吃瓜</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/"
                  ? "text-primary-500"
                  : "text-foreground-700 hover:text-primary-500"
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname.startsWith("/category")
                    ? "text-primary-500"
                    : "text-foreground-700 hover:text-primary-500"
                }`}
              >
                分类浏览
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${categoryOpen ? "rotate-180" : ""}`}></i>
              </button>

              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-background-50 rounded-lg shadow-lg border border-background-200/70 py-2 z-50">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      <i className={`${cat.icon} mr-2`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === "/about"
                  ? "text-primary-500"
                  : "text-foreground-700 hover:text-primary-500"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-foreground-700 bg-background-100 rounded-full hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-search-line"></i>
              搜索
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <Link
            to="/"
            className="block py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap"
          >
            首页
          </Link>
          <p className="py-3 text-sm font-medium text-foreground-700 whitespace-nowrap">分类浏览</p>
          <div className="ml-4 space-y-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="block py-2 text-sm text-foreground-600 hover:text-primary-500 whitespace-nowrap"
              >
                <i className={`${cat.icon} mr-2`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
          <Link
            to="/about"
            className="block py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap"
          >
            关于我们
          </Link>
        </div>
      )}
    </nav>
  );
}